import { ProductConfig } from "@core/interface/environment.interface";
import { ProductEnum } from "../product.enum";

export const TravelEnvironment: ProductConfig = {
    baseUrl: "",
    schemaEndpoint: "./api/v1/travel-report",
    productUrl: ProductEnum.TRAVEL,
    maxSingleFileSizeUpload: null,
    maxBulkFilesSizeUpload: 19000000,
    deployUrl: ProductEnum.TRAVEL + '/'
};
